export default __webpack_public_path__ + "static/SharpSansNo1-Bold-861b48f3e9368a8f7724d190dc2e69c2.woff2";